import { Button, Card } from 'antd'
import { ColumnProps } from 'antd/lib/table'
import React from 'react'
import { Link } from 'react-router-dom'

const DegummingDetailedView = () => {

    const colums:ColumnProps<any>[] = [
      {
        title:"Degumming Input Qty",
        dataIndex:"degummingInputQty"
      },
      {
        title:"Degumming Output Qty",
        dataIndex:"degummingOutputQty"
      }
    ]
  return (

    <div>
      <Card
              title={<span style={{ color: 'white' }}>Degumming</span>}
              style={{ textAlign: 'center' }}
              headStyle={{ backgroundColor: '#69c0ff', border: 0 }}
              extra={
                <span>
                  <Button>
                    <Link to="/degumming">View</Link>
                  </Button>
                </span>
              }
            >DegummingDetailedView</Card>
      </div>
  )
}

export default DegummingDetailedView